
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1405 139"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M179.71.8h36.7v47.41H303V.8h36.72v137.71h-36.53V81.26h-86.76v57.25h-36.72zM396.18 138.51h-37V.8h36.62v47.49h86.63V.8h36.87v137.71h-36.75V81.2h-86.37zM1244.23 138.51V49.63h160.37V81.5h-123.12v25.16h123.06v31.85zM829.28 49.88c2.1-1.2 3.8-.8 5.42-.8h131c15.66 0 24.52 8.84 24.52 24.35v43c0 13.21-9.26 22-22.73 22-35 .08-70 0-105 0h-32.84v-31.49h123.08V82.1c-1.75-1.15-3.8-.61-5.74-.61q-47-.06-94 0c-15.9 0-23.7-7.74-23.72-23.51zM123.41 105.71v-24.5h-33V49.1h70.26v89.41h-6.1c-43.31 0-86.63.06-130 0C8.29 138.49 0 130.19 0 113.87V49.1h37v56.61zM810.34 138.51h-36.29V65.65H650.21V33.18h135.58c6 0 11.6 1.11 16.53 4.65 5.15 3.7 8.43 8.67 8.46 15.11.11 28 0 57.62 0 85.61.02.45-.23-.78-.44-.04zM1244.36.8h160.28v32.58h-160.28zM1065 33.14V.8h160.11v32.34zM160.7.8v31.74H.29c0-4.9-.58-9.76.11-14.43C1.93 7.78 10.84 1.07 22.07.8c8-.19 16 0 24 0H160.7zM989.92.8v32.28H829.53c-.07-6-.76-11.8.73-17.5C832.54 6.86 840.46.85 850 .8c16.82-.07 33.64 0 50.46 0h89.42zM1126.88 49.47h36.33v89h-36.33zM630.93 138.51h-36.45V49.32h36.45zM1009.09 138.51v-89.3h36.6v89.3z"}}),_c('path',{attrs:{"d":"M650.32 81.46h36.32v57.05h-36.32zM1045.65 32.88h-36.45V.8h36.45zM594.5.8h36.4v31.94h-36.4z"}})])
          )
        }
      }
    